<template>
  <div class="body_admin">
    <div class="left_color full_height">.</div>
    <div class="application_layout">
      <header id="header" class="u-header--starter">
        <nav id="logoAndNav" class="shadow_bar navbar navbar-dark lex-nowrap bg_menu p-0 bg_black">
          <div
            class="bg_light_menu col-xl-2 col-md-2 center col-lg-2 navbar-brand u-header__navbar-brand mr-0 py-3 pf-5"
            style="background-color: #27292d"
          >
            <inertia-link href="/recruiters/dashboard">
              <img src="/images/LOGO_JOVOOL.png" width="120px" />
            </inertia-link>
          </div>

          <div
            class="input-group  input-group-xs input-group-borderless d-md-flex mr-auto ml-md-4"
            style="max-width: 700px; ;"
          >
            <h2 class="f25 mt-3 font-jovool color-light-grey">{{title ? title : ''}}</h2>
            <div class="input-group-prepend hide">
              <span class="input-group-text bg-primary2" id="docsSearch">
                <span class="fas fa-search"></span>
              </span>
            </div>
            <input
              id="input_search"
              class="js-hs-docs-search hide form-control pl-0 ui-autocomplete-input"
              type="text"
              placeholder="Pesquisar..."
              style="height: 36px; padding-right: 5px"
              aria-label="Pesquisar..."
              aria-describedby="docsSearch"
            />
          </div>

          <div class="mr-3">
            <button class="hidebtn hide btn-outline-success">Upgrade Plan</button>
          </div>
          <!-- <CalendarButton></CalendarButton> -->
          <div class="dropdown white_font" style="margin-right: 5px;  user-select: none;">
            <a
              class="dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img :src="picture" class="img_avatar_small" />
            </a>
            <div
              class="dropdown-menu p-2 bg-light-grey"
              style="margin-left: -90px"
              aria-labelledby="dropdownMenuButton"
            >
              <inertia-link
                href="/recruiters/profile/edit"
                class="btn full mt-1 mb-1 btn-dark user-dropdown-item"
              >Perfil</inertia-link>
              <button @click="logout" class="btn full mt-1 mb-1 btn-dark user-dropdown-item">Logout</button>
            </div>
          </div>
        </nav>
      </header>
      <div class="container-fluid">
        <div class="row">
          <div
            class="col-lg-2 no_padding_left shadow_bar_right pt-4 col-md-2 col-xs-12 bg_menu bg_menu_dark full_height"
          >
            <MenuAdminItem
              label="Dashboard"
              url="/admins/dashboard"
              img="/images/DASHBOARD_ICON.png"
              img_active="/images/DASHBOARD_COLOR_ICON.png"
              :active="menu"
            />

            <MenuAdminItem
              label="Planos"
              url="/admins/plans"
              img="/images/VAGA_ICON.png"
              img_active="/images/VAGA_COLOR_ICON.png"
              :active="menu"
            />

            <MenuAdminItem
              label="Transações"
              url="/admins/transactions"
              img="/images/PAGAMENTOS_ICON.png"
              img_active="/images/PAGAMENTOS_COLOR_ICON.png"
              :active="menu"
            />

            <MenuAdminItem
              label="Licenças"
              url="/admins/accounts"
              img="/images/CONFIGURACOES_ICON.png"
              img_active="/images/CONFIGURACOES_ICON.png"
              :active="menu"
            />
          </div>
          <div class="col-lg-10 p-4 col-md-2 col-xs-12 body_admin dark_theme color-light-grey">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import MenuAdminItem from "components/MenuAdminItem.vue";
import CalendarButton from "@/Recruiters/Calendar/CalendarButton.vue";
export default {
  props: ["title", "menu"],
  components: { MenuAdminItem, CalendarButton },
  data() {
    return {
      picture: "/images/avatar.png",
    };
  },
  mounted() {
    localStorage.getItem("avatar-url")
      ? (this.picture = localStorage.getItem("avatar-url"))
      : false;
  },
  methods: {
    logout() {
      axios
        .delete("/admins/sign_out")
        .then((resource) => {
          // console.log(resource);
          window.location = "/";
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
